<form [formGroup]="configurationFormFtp">
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-url" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.url' | translate }}</label>
      <input id="ic-url" type="text" class="form-control" formControlName="url" />
      <app-error-messages [control]="configurationFormFtp.controls.url"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-ftpClientType" class="control-label required">{{'i18n.domain.import-configuration.edit.general.transfer-type' | translate}}</label>
      <ejs-dropdownlist [dataSource]="ftpTypes"
                        [fields]="enumDropdownSettings"
                        id="ic-ftpClientType"
                        formControlName="ftpClientType">
        <ng-template #itemTemplate let-data>
          {{data.text | translate}}
        </ng-template>
        <ng-template #valueTemplate let-data>
          <div class="centered">
            <span>{{data.text | translate}}</span>
          </div>
        </ng-template>
      </ejs-dropdownlist>
      <app-error-messages [control]="configurationFormFtp.controls.ftpClientType"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-port" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.port' | translate }}</label>
      <input id="ic-port" type="number" class="form-control" formControlName="port" />
      <app-error-messages [control]="configurationFormFtp.controls.port"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-userName" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.username' | translate }}</label>
      <input id="ic-userName" type="text" class="form-control" formControlName="userName" />
      <app-error-messages [control]="configurationFormFtp.controls.userName"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-password" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.password' | translate }}</label>
      <input id="ic-password" type="text" class="form-control" formControlName="password" />
      <app-error-messages [control]="configurationFormFtp.controls.password"></app-error-messages>
    </div>
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-relativePath" class="control-label">{{ 'i18n.domain.import-configuration.edit.ftp.relative-path' | translate }}</label>
      <input id="ic-relativePath" type="text" class="form-control" formControlName="relativePath" />
      <app-error-messages [control]="configurationFormFtp.controls.relativePath"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-deleteFilesAfterTransmission" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.delete-file' | translate }}</label>
      <app-yes-no-group-button id="ic-deleteFilesAfterTransmission" formControlName="deleteFilesAfterTransmission"></app-yes-no-group-button>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-xl-4 col-lg-6">
      <label for="ic-useCertificate" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.certificate' | translate }}</label>
      <app-yes-no-group-button id="ic-useCertificate" formControlName="useCertificate"></app-yes-no-group-button>
    </div>
  </div>
  @if (configurationFormFtp.controls.useCertificate.value === true) {
    <div class="form-row row">
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificateMediaName" class="control-label required">{{ 'i18n.domain.import-configuration.edit.ftp.certificate-name' | translate }}</label>
        <input id="ic-certificateMediaName" type="text" class="form-control" formControlName="certificateMediaName"/>
        <app-error-messages [control]="configurationFormFtp.controls.certificateMediaName"></app-error-messages>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificateMedia" class="control-label required">{{'i18n.domain.import-configuration.edit.ftp.certificate-upload' | translate}}</label>
        <ejs-uploader #defaultupload
                      id="ic-certificateMedia"
                      allowedExtensions=".cer,.pfx,.ppk,.p7b,.p7c,.pem,.pub"
                      multiple="false"
                      [autoUpload]="false"
                      (removing)="onFileRemove()"
                      (selected)="handleFileInput($event)">
        </ejs-uploader>
      </div>
      <div class="form-group col-xl-4 col-lg-6">
        <label for="ic-certificatePassword" class="control-label">{{ 'i18n.domain.import-configuration.edit.ftp.certificate-password' | translate }}</label>
        <input id="ic-certificatePassword" type="text" class="form-control" formControlName="certificatePassword" />
        <app-error-messages [control]="configurationFormFtp.controls.certificatePassword"></app-error-messages>
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-12 d-flex align-items-center gap-2">
      <button type="button"
              [disabled]="!configurationFormFtp.valid"
              (click)="testFtpAccess()"
              class="btn btn-outline-secondary">
        {{'i18n.domain.import-configuration.edit.ftp.test-ftp-access' | translate}}
      </button>
      <div>
        @if (isTestingConnection) {
          <div class="spinner-border spinner-border-sm" role="status"></div>
        }
        @if (!isTestingConnection && ftpConnectionResponse) {
          <div class="align-items-center">
            @if (ftpConnectionResponse.succeeded) {
              <span class="text-success">{{'i18n.domain.import-configuration.edit.ftp.connection-success' | translate}}</span>
            }
            @if (!ftpConnectionResponse.succeeded) {
              <span class="text-danger cursor-pointer hover-underline" (click)="showLog()">
                {{'i18n.domain.import-configuration.edit.ftp.connection-failed' | translate}}
                <span class="text-danger icon-task--view"></span>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</form>

<ejs-dialog #dialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false">
  <ng-template #header>
    {{'i18n.domain.import-configuration.edit.ftp.logfile' | translate}}
  </ng-template>
  <ng-template #content>
    <pre>{{formattedLog}}</pre>
  </ng-template>
  <ng-template #footerTemplate>
    <ng-container>
      <button class="btn btn-secondary mr-2" (click)="closeLog()">{{'i18n.shared.close' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
